module.exports = __webpack_public_path__ + "img/stapel-03.9da7b723.svg";